<template>
    <div class="content-box" id="msg-page">
      <!-- header start -->
      <van-nav-bar
        title="余额转积分"
        fixed
        :placeholder="true"
        :z-index="99"
        left-arrow
        right-text="切换"
        @click-right="onChagePage"
        @click-left="goBack"
  
      />
      <!-- header end -->
  
      <div class="tixian-panel">
        <div class="tixian-form">
          <div class="form-title">余额转积分</div>
          <div class="form-control">
            <span class="code">￥</span>
            <input
              v-model="input.cash"
              class="input"
              placeholder="请输入需要转换余额"
              value="0"
              type="digit"
            />
          </div>
          <div class="form-btm" v-if="member != null">
            <div class="bd flexbox">
              <!-- <div class="yue ellipsis">账户余额0.00元</div> -->
              <div class="t14 hlight">账户余额:{{ member.HasCash }}</div>
            </div>
            <div class="t14 hlight" @click="onAllTrun">全部转换</div>
          </div>
        </div>
      </div>
  
      <div class="btn-area">
        <van-button round color="#24a378" @click="onSubmit" block
          >立即转换</van-button
        >
        <van-button round color="#24a378" plain block to="/yeGive"
          >转换明细</van-button
        >
      </div>
    </div>
  </template>
  
  <script>
  import common from "../../../tools/common";
  export default {
    data() {
      return {
        options: {
          type: "TrunCashInCoin"
        },
        input: {
          cash: 0,
          remark: ""
        },
        member: null
      };
    },
    components: {},
    methods: {
      init() {
        var that = this;
        this.$store
          .dispatch({
            type: "GetMemberInfo"
          })
          .then(res => {
            that.member = res;
          });
      },
      goBack() {
        this.$router.go(-1);
      },
      onAllTrun() {
        var _cash = this.member.HasCash;
        this.input.cash = _cash;
      },
      onSubmit() {
        var that = this;
        if (!/\d+/.test(this.input.cash)) {
          this.$toast("金额不能为空,必须为数字类型！");
          return false;
        }
        else if(this.input.cash<=0){
          this.$toast("金额必须大于0！");
          return false;
        }
  
        Object.assign(this.options, {
          ...this.input
        });
        that.$store.dispatch(this.options).then(res => {
          console.log(res,"yeGiveForm");
          if(res.Result.IsSuccess){
              Object.assign(this.input, {
                cash: 0,
                remark: ""
              });
              that.init();
          }

        });
      },
      onChagePage(){
        this.$router.replace("/yeGiveForm2")
  
      }
    },
    created() {
      this.init();
    }
  };
  </script>
  
  <style lang="less" scoped>
  .tixian-panel {
    margin: 10px 0;
    background-color: #fff;
  }
  .tixian-form {
    & > .form-title {
      padding: 15px 15px 0;
      font-size: 16px;
      color: #333;
    }
    & > .form-control {
      padding: 12px 15px;
      display: flex;
      align-items: center;
      background: #f8f8f8;
      margin: 10px 15px 0;
      & > .code {
        font-size: 13px;
        color: #000;
        font-weight: normal;
        margin-right: 15px;
      }
      & > .input {
        font-size: 15px;
        color: #000;
        font-weight: normal;
      }
    }
    & > .form-btm {
      padding: 14px 15px;
      display: flex;
      align-items: center;
      overflow: hidden;
      & > .bd {
        flex: 1;
        overflow: hidden;
        & > .yue {
          font-size: 14px;
          color: #444;
          margin-right: 10px;
        }
      }
    }
  }
  .btn-area {
    margin: 24px 10% 0;
    padding: 0 0 15px 0;
    .van-button {
      margin-bottom: 14px;
    }
  }
  </style>
  